module.exports = __webpack_public_path__ + "img/21_40.6ce8c50d.png";